import type { MatchItem, MatchCategory, MatchRound } from "./types";

/**
 * Given a pool of items + category set, produce a shuffled round of N items.
 * Deterministic when a seed is provided (for reproducible tests).
 */
export interface GenerateOpts {
  itemsPerRound: number;
  seed?: number;
}

export class RoundGenerator {
  static generate(
    pool: MatchItem[],
    categories: MatchCategory[],
    opts: GenerateOpts
  ): MatchRound {
    const shuffled = shuffle(pool, opts.seed);
    const items = shuffled.slice(0, opts.itemsPerRound);
    return {
      id: `round-${Date.now()}`,
      items,
      categories,
      timeAllowedMs: null
    };
  }
}

function shuffle<T>(input: T[], seed?: number): T[] {
  const arr = input.slice();
  let rand = seed !== undefined ? mulberry32(seed) : Math.random;
  for (let i = arr.length - 1; i > 0; i--) {
    const j = Math.floor(rand() * (i + 1));
    [arr[i], arr[j]] = [arr[j], arr[i]];
  }
  return arr;
}

function mulberry32(seed: number): () => number {
  let a = seed;
  return () => {
    a |= 0;
    a = (a + 0x6d2b79f5) | 0;
    let t = a;
    t = Math.imul(t ^ (t >>> 15), t | 1);
    t ^= t + Math.imul(t ^ (t >>> 7), t | 61);
    return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
  };
}
